import { Pipe, PipeTransform } from '@angular/core';
import { CompanyBasic } from '../models';

@Pipe({
    name: 'rmsCompanyTicker',
    standalone: false
})
/**
 * Ticker data transform class
 */
export class RmsCompanyTickerPipe implements PipeTransform {

  /**
   * Gets the Company Data and returns:
   * private as string if the company is actually private
   * If it is not private, returns the ticker
   * @param {CompanyBasic} value
   * @param args
   * @returns {string}
   */
  transform(value: CompanyBasic, args?: any): string {
    return value.isPrivate ? 'PRIVATE' : value.ticker;
  }

}
